import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { ModalNextProvider } from '@jutro/components';
import { ImageComponent } from 'gw-components-platform-react';
import { TranslatorContext } from '@jutro/locale';
import _ from 'lodash';
import { messages as commonMessages } from 'gw-platform-translations';
import DamageList from './DamageList';
import styles from './VehicleDamagePicker.module.scss';
import carParts from './VehicleParts.json';
import messages from './VehicleDamagePicker.messages';

class VehicleDamagePicker extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        collisionPoints: PropTypes.shape({
            getCode: PropTypes.func
        }).isRequired,
        onValueChange: PropTypes.func.isRequired,
        path: PropTypes.string.isRequired,
        categoryValue:PropTypes.string.isRequired,
        value: PropTypes.shape({
            code: PropTypes.string
        }).isRequired
    };

    state = {
        damagedParts: [],
        hovered: false,
        hoveredPart: null,
        categoryValue:null
    };

    selectPart = ( partID) => {
            let count =0;
            const newDamageParts = this.state.damagedParts.map((selectedPart) => {
                if(selectedPart.damagePoint === partID) {
                    switch (selectedPart.damageSeverity) {
                        case 'minor':
                            selectedPart.damageSeverity = 'moderate';
                            count++;
                            break;
                        case 'moderate':
                            selectedPart.damageSeverity = 'severe';
                            count++;
                            break;
                        case 'severe':
                            count--;
                            this.offDamage(partID,this.state.damagedParts);
                            break;
                    }
                }
                return selectedPart;
            }); 
            if(count > 0){
                this.setState(
                    {
                        damagedParts: newDamageParts
                    },
                    () => {
                        this.onCallBack();
                    }
                );
            }else if(count === 0){
                const newDamagePt =  {damagePoint: partID, damageSeverity: "minor", isDamaged: true}
                this.setState(
                    {
                        damagedParts: [...this.state.damagedParts, newDamagePt]
                    },
                    () => {
                        this.onCallBack();
                    }
                );
            }
    };

    getClassName = (className) => {
        return cx(styles.gw_car_part, styles[className]);
    };
    
    getIcon = (partName, part) => {
        const { hovered, hoveredPart } = this.state;
        let damageSeverity = 'minor';
        //debugger;
        const foundIndex = _.findIndex(this.state.damagedParts, (e) => {
            return e.damagePoint == part;
        });
        if(foundIndex !== -1 ){
            damageSeverity = this.state.damagedParts[foundIndex].damageSeverity;
        }
        if (hovered && hoveredPart === partName) {
            return `/newclaimvehicle/${damageSeverity}/damage_${partName}_hover.gif`;
        }
        if (foundIndex !== -1) {
            return `/newclaimvehicle/${damageSeverity}/damage_${partName}_on.gif`;
        }
        return `/newclaimvehicle/damage_${partName}_off.gif`;

        // if (value ) {
        //     return `/newclaimvehicle/onhover/damage_${part}_on.gif`;
        // }

    };

    onHover = (hovered, part) => {
        this.setState({ hovered, hoveredPart: part });
    };

    handleKeyDown = (event, group, part) => {
        if (event.keyCode === 'Enter') {
            this.selectPart(group, part);
        }
    };

    offDamage = (part, selectedDamagedPart) => {
        const removeIdx = _.findIndex(selectedDamagedPart, (e) => {
            return e.damagePoint == part;
        });
        if (removeIdx !== -1) {
            selectedDamagedPart.splice(removeIdx, 1);
        }
        this.setState({ damagedParts: selectedDamagedPart}, () => {
            this.onCallBack();
        });
    };

    onCallBack = () => {
        const { damagedParts } = this.state;
        const { onValueChange, path } = this.props;
        const value = !_.isEmpty(damagedParts) ? damagedParts : null;
        if (onValueChange) {
            onValueChange(value, path);
        }
    };

    render() {
        const translator = this.context;
        //const { damagedParts } = this.state;
        const stateCategory = this.state.categoryValue;
        const {value,categoryValue } = this.props;
        const damages = !_.isNil(value) && !_.isEmpty(value)? value : [];
        
        if(!stateCategory || stateCategory !==categoryValue)
        this.setState(
            {
                damagedParts: damages,
                categoryValue:categoryValue
            });
        //const listOfDamages = !_.isEmpty(damagedParts) ? damagedParts : availableDamageParts;
        const vehicleImageClass = cx(styles.gw_car, styles.gw_damage_picker);
        const carOrVanparts = categoryValue && categoryValue == 'light_comm' ? carParts.vanparts : carParts.carparts
        return (
            <div className={styles.gwCarContainer}>
                <div className={vehicleImageClass}>
                    <ImageComponent
                        id="vehicleDamageDiagram"
                        src="/newclaimvehicle/damage_diagram.gif"
                        alt="damageVehiclePart"
                    />
                    {carOrVanparts.map((carpart, index) => (
                        <span
                            id={`carParts${index}`}
                            key={carpart.partName}
                            className={this.getClassName(carpart.class)}
                            tabIndex={index}
                            part={carpart.partName}
                            onMouseEnter={() => this.onHover(true, carpart.partName)}
                            onMouseOut={() => this.onHover(false)}
                            onBlur={() => this.onHover(false)}
                            onClick={() => this.selectPart(carpart.part, carpart.partName)}
                            onKeyDown={(e) => this.handleKeyDown(e, carpart.part, carpart.partName)}
                            role="button"
                        >
                            <ImageComponent
                                src={this.getIcon(carpart.partName,carpart.part)}
                                tabIndex={index}
                                id={carpart.partName}
                                alt="damageParts"
                            />
                        </span>
                    ))}
                </div>
                <div className={styles.damageseveritylegend}>
                    <ul className={styles.legendlabels}>
                        <li><span className={styles.minorseverity} />
                            Minor Damage click once
                        </li>
                        <li><span className={styles.moderateseverity} />
                            Moderate Damage click twice
                        </li>
                        <li><span className={styles.severeseverity} />
                            Major Damage click three times
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default VehicleDamagePicker;
